import type { StylePropItem } from '@wix/thunderbolt-becky-root'
import type { Spx } from '@wix/thunderbolt-becky-types'
import type { StylePropertiesTypes } from '@wix/document-services-types'

// Flexible type definition for converter mappings that avoids complex union type errors
export interface StyleConverterMappings {
	// Use index signature for maximum flexibility while maintaining some typing
	[key: string]: (prop: any, spx?: any) => string | Record<string, any>
}

// Registry to store style property converters
export const convertersRegistry = new Map<string, unknown>()

/**
 * Enriches the converters registry with a converter function
 * @param key - The converter key
 * @param value - The converter function
 */
export function enrichConvertersRegistry(
	key: string,
	value: (prop: any, spx?: any) => string | Record<string, any>
): void {
	convertersRegistry.set(key, value)
}

type ConvertableType = StylePropItem | StylePropertiesTypes.MathFunctionValueTypes | StylePropertiesTypes.MathOperation

/**
 * Retrieves a converter from the registry
 * @param key - The converter key to retrieve
 * @returns The converter function or undefined if not found
 */
export function getConverter(
	key: string
): ((prop: ConvertableType, spx?: Spx) => string | Record<string, any>) | undefined {
	return convertersRegistry.get(key) as
		| ((prop: ConvertableType, spx?: Spx) => string | Record<string, any>)
		| undefined
}

/**
 * Checks if a converter exists in the registry
 * @param key - The converter key to check
 * @returns True if the converter exists, false otherwise
 */
export function hasConverter(key: string): boolean {
	return convertersRegistry.has(key)
}

/**
 * Gets all registered converter keys
 * @returns Array of all registered converter keys
 */
export function getRegisteredConverterKeys(): Array<string> {
	return Array.from(convertersRegistry.keys())
}
